import React from 'react';
import Text from 'components/Text/Text';
import { DnDList } from './components/DnDList/DnDList';
import classNames from 'classnames';
import style from './ChangePositionList.module.scss';

export const ChangePositionList: React.FC = () => {
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const categoryTypeHeadingClasses = classNames(style.categoryType, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};
